import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  inject,
} from '@angular/core';

@Component({
  selector: 'lib-card',
  templateUrl: 'card.component.html',
})
export class CardComponent implements AfterViewInit {
  private readonly cdRef = inject(ChangeDetectorRef);

  @ViewChild('footerTemplate', { static: true }) footerTemplate!: ElementRef;
  @Input() title: string = '';
  @Input() body: string | TemplateRef<any> = '';
  @Input() headerClass: string = '';
  @Output() cardClicked = new EventEmitter<any>();

  showFooter: boolean = true;

  ngAfterViewInit(): void {
    this.showFooter = this.footerTemplate.nativeElement && this.footerTemplate.nativeElement.children.length > 0;
    this.cdRef.detectChanges();
  }
}
